<template>
    <div>
        <form-header v-if="opt == 'create'" :page-name="pageName"></form-header>
        <form-header v-else :page-name="pageName" do-cust @cust="backPage"></form-header>
        <div class="container">
            <div class="card mb-2">
                <div class="card-body">

                    <!-- 契約状態 -->
                    <form-input ref="contract_flg" ip-type="select" :errs-nm="['contract_flg']" :s-opt="contractFlgList" val-nm="val" 
                                lab-nm="lab" dft="0" lab="契約状態" required></form-input>

                    <!-- 応募ID -->
                    <form-input ref="apply_id" :errs-nm="['apply_id']" lab="応募ID" plhd="例：123" numeric :max-length="20"></form-input>

                    <!-- 案件会社 -->
                    <form-input ref="pj_group" ip-type="inputmodal" :errs-nm="['pj_group', 'pj_group_nm']"
                        lab="案件会社" dft2="-- 選択 --" required @pj_group_modal_open="pjCompanyModalOpen"></form-input>

                    <!-- 案件名 -->
                    <form-input ref="pj_nm" ip-type="textarea" :errs-nm="['pj_nm']" lab="案件名" :row="2" :has-trim="false" :no-blank="false"
                                plhd="例：○○○システム構築" :max-length="150" has-len></form-input>

                    <!-- 案件ID -->
                    <form-input ref="pj_id" :errs-nm="['pj_id']" lab="案件ID" plhd="例：123" numeric :max-length="20"></form-input>

                    <!-- 要員会社 -->
                    <form-input ref="te_group" ip-type="inputmodal" :errs-nm="['te_group', 'te_group_nm']"
                        lab="要員会社" dft2="-- 選択 --" required @te_group_modal_open="teCompanyModalOpen"></form-input>

                    <!-- 所属関係 -->
                    <form-input ref="relation_cmp" ip-type="select" :errs-nm="['relation_cmp']" :s-opt="relationCmpList" val-nm="val" 
                                lab-nm="lab" lab="所属関係"></form-input>

                    <!-- 要員名前 -->
                    <form-input ref="private_nm" :errs-nm="['private_nm']" lab="要員名前" plhd="例：ぷろ太郎" required :max-length="20"></form-input>

                    <!-- ユーザーID -->
                    <form-input ref="user_id" :errs-nm="['user_id']" lab="ユーザーID" plhd="例：123" numeric :max-length="20"></form-input>

                    <!-- 履歴ID -->
                    <form-input ref="te_id" :errs-nm="['te_id']" lab="履歴書ID" plhd="例：123" numeric :max-length="20"></form-input>

                    <div class="text-center text-danger mt-4">
                        <p>=== 契約期間 ===</p>
                    </div>

                    <!-- 契約開始 -->
                    <form-input ref="start_date" :errs-nm="['start_date']" lab="契約開始" plhd="例：20210101" numeric required :max-length="8" :length="[true,8]" valid-date></form-input>
                    
                    <!-- 契約終了 -->
                    <form-input ref="end_date" :errs-nm="['end_date']" lab="契約終了" plhd="例：20210101" numberic required :max-length="8" :length="[true,8]" valid-date></form-input>

                    <!-- 備考 -->
                    <form-input ref="note" ip-type="textarea" :errs-nm="['note']" lab="備考" :row="5" 
                                plhd="必要に応じて記入してくさだい。" :max-length="2000" has-len></form-input>

                    <!-- 会社選択 -->
                    <select-company ref="selectCompany" :list="companys"></select-company>

                    <div class="card mb-2 mt-5">
                        <div class="card-body">
                            <div class="row form-group justify-content-center mb-0">
                                <div class="col-sm-3">
                                    <button class="btn btn-success btn-block btn-lg" @click="dataCheck">
                                        <i class="fas fa-eye"></i>&nbsp;確認画面へ
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormInput from 'pages/commons/form/Input'
    import FormHeader from 'pages/commons/header/Header'
    import SelectCompany from 'pages/commons/modal/selectCompany/SelectCompany'

    import {mapGetters} from 'vuex'

    export default {
        props: {
            opt: String
        },
        components: {
            FormInput,
            FormHeader,
            SelectCompany,
        },
        data () {
            return {
                companys: [],
                contractFlgList: this.makeContractFlgList(),
                relationCmpList: this.makeRelationCmpList(),
                reqForm: {},
                resultArr: [],
                formArr:[
                        'contract_flg'
                        ,'apply_id'
                        ,'pj_group'
                        ,'pj_nm'
                        ,'pj_id'
                        ,'te_group'
                        ,'relation_cmp'
                        ,'private_nm'
                        ,'user_id'
                        ,'te_id'
                        ,'start_date'
                        ,'end_date'
                        ,'note'
                    ],
            }
        },
        watch: {
            getContractInfo (info) {
                if (info.data.contract) {
                    this.setDefaultVal(info.data.contract)
                }
                this.companys = info.data.companys
            },
        },
        computed: {
            pageName () {
                return this.opt == 'create' ? "契約情報入力" : "契約情報編集"
            },
            ...mapGetters(['getContractInfo'])
        },
        methods: {
            backPage () {
                this.$parent.changeOperat('show')
            },
            setDefaultVal (info) {
                // 編集ボダン押下
                if (info.contract_flg) {
                    this.$refs.contract_flg.setInputData(info.contract_flg)
                }
                if (info.apply_id) {
                    this.$refs.apply_id.setInputData(info.apply_id)
                }
                if (info.pj_group) {
                    this.$refs.pj_group.setInputData(info.pj_group, info.pj_group_nm)
                }
                if (info.pj_nm) {
                    this.$refs.pj_nm.setInputData(info.pj_nm)
                }
                if (info.pj_id) {
                    this.$refs.pj_id.setInputData(info.pj_id)
                }
                if (info.te_group) {
                    this.$refs.te_group.setInputData(info.te_group, info.te_group_nm)
                }
                if (info.relation_cmp) {
                    this.$refs.relation_cmp.setInputData(info.relation_cmp)
                }
                this.relationSet(info.user_group)
                if (info.private_nm) {
                    this.$refs.private_nm.setInputData(info.private_nm)
                }
                if (info.user_id) {
                    this.$refs.user_id.setInputData(info.user_id)
                }
                if (info.te_id) {
                    this.$refs.te_id.setInputData(info.te_id)
                }
                this.$refs.start_date.setInputData(info.start_date)
                this.$refs.end_date.setInputData(info.end_date)
                if (info.note) {
                    this.$refs.note.setInputData(info.note)
                }
            },
            getChildData () {
                this.formArr.forEach(item => {
                    var formData = this.$refs[item].getData()
                    this.reqForm = Object.assign({},this.reqForm, formData)
                })
            },
            getData() {
                return this.reqForm
            },
            dataCheck () {

                  /** test 用start **/
               // this.getChildData()
               // this.$parent.getChildData()
               // this.$parent.changeOperat('auto')
                  /** test 用end **/

                this.checkForm()
                this.doDataCheck ()
            },
            doDataCheck () {
                Promise.all(this.resultArr)
                    .then((res) => {
                        this.getChildData()
                        this.$parent.getChildData()
                        this.$parent.changeOperat('auto')
                    })
            },
            checkForm () {
                this.resultArr = []
                this.formArr.forEach(formName => {
                    this.doCheckForm(formName)
                })
            },
            doCheckForm (formName) {
                var result = new Promise((resolve, reject) => {

                    let valid = this.$refs[formName].dataCheck()           
                    if (valid) { 
                        resolve() }
                })
                this.resultArr.push(result)
            },
            pjCompanyModalOpen () {
                this.$refs.selectCompany.openThis({name:'pj', pjOpt:true})
            },
            teCompanyModalOpen () {
                this.$refs.selectCompany.openThis({name:'te', teOpt:true})
            },
            pjCompanySet (val) {
                this.$refs.pj_group.setInputData(val.user_group, val.name)
            },
            teCompanySet (val) {
                this.$refs.te_group.setInputData(val.user_group, val.name)
                this.relationSet(val.user_group)
            },
            relationSet (group) {
                if (group == 'none') {
                    this.relatRequired = false
                    this.$refs.relation_cmp.setInputData("")
                    this.$refs.relation_cmp.setDisabled(true)
                } else {
                    this.relatRequired = true
                    this.$refs.relation_cmp.setDisabled(false)
                }
            },
            makeContractFlgList () {
                return this.$parent.getList('contract_flg')
            },
            makeRelationCmpList () {
                return this.$parent.getList('relation_cmp')
            },
        }
    }
</script>

<style lang="stylus" scoped>
    

</style>
